import { useEffect, useState } from 'react';
import { SelectItem } from '@/components/ui/select';
import { SelectField } from '@/components/dropdowns/SelectField/SelectField';
import { useFonts } from '@/context/FontProvider';
import type { FormProps } from '@builder4/shared/components/Form';
import { useInspectorNode } from '@/hooks/useInspectorNode';
import { useBreakpointAwareProp } from '@/hooks/useBreakpointAwareProp';
import { FORM_NODE_NAME } from '@/utils/constants';

const NodeFieldLabelFontFamily = ({ className = 'w-full' }: { className?: string }) => {
  const { fonts } = useFonts();
  const { id, actions, props: nodeProps, node } = useInspectorNode<Partial<FormProps>>();

  const { getBPProp, setBPProp } = useBreakpointAwareProp(node?.data.displayName || FORM_NODE_NAME);

  // Read props using breakpoint-aware getter
  const fieldLabelFontFamily = getBPProp(nodeProps, 'fieldLabelFontFamily');

  const [currentFont, setCurrentFont] = useState(fieldLabelFontFamily || 'Inter');

  useEffect(() => {
    setCurrentFont(fieldLabelFontFamily || 'Inter');
  }, [fieldLabelFontFamily]);

  const handleFontChange = (family: string) => {
    actions.setProp(id, (props: FormProps) => {
      setBPProp(props, 'fieldLabelFontFamily', family, FORM_NODE_NAME);
      // Reset weight when changing font
      setBPProp(props, 'fieldLabelFontWeight', 400, FORM_NODE_NAME);
    });
  };

  return (
    <SelectField
      onValueChange={handleFontChange}
      className={className}
      defaultValue={currentFont}
      size="small"
      text="Font"
    >
      {fonts.length > 0 ? (
        fonts.map((font) => (
          <SelectItem
            key={font.family}
            value={font.family}
            style={{
              fontFamily: font.family,
              fontSize: '14px',
            }}
          >
            {font.family}
          </SelectItem>
        ))
      ) : (
        <SelectItem value="Inter">Inter</SelectItem>
      )}
    </SelectField>
  );
};

export default NodeFieldLabelFontFamily;
